<template>
  <!-- 赛程 -->
  <div class="com-sch">
    <!-- 赛程情况 -->
    <div class="sch-info">
      <div class="sch-left">
        <div class="title">
            <div class="sta-middle">
                <div class="sta-title"><span class="dot  blue"></span> 比赛日</div>
                <div  class="sta-title"><span class="dot  yellow"></span>决赛日</div>
            </div>
            <div>项目</div>
        </div>
          <div class="l-row" v-for="item,index in newProjectList" :key="index" :style="{'background-color':index%2==1?'#F7FBFD':''}">
            <div class="l-col">
              <div>{{item.title}}</div>
            </div>
          </div>
      </div>
      <div class="sch-middle">
        <div class="title">
          <div class="t-item" v-for="item,index in dataList"  :key="index">
            <div class="m">{{item.m?Number(item.m)+"月":''}}</div>
            <div class="line">
                <div class="d">{{item.d}}</div>
                <div class="w">{{item.week}}</div>
            </div>
          </div>
        </div>
        <div class="m-row"  v-for="item,index in newProjectList" :key="index" >
          <div class="m-col" v-for="item,ind in calculationTime.getStartEndAllDays('2023/02/03','2023/02/22', item.dayList)" :key="ind" :style="{'background-color':index%2==1?'#F7FBFD':''}">
             <a-popover placement="bottom" v-if="item.status" :getPopupContainer=" triggerNode => { return triggerNode.parentNode}">
                <template slot="content">
                  <div class="popo">
                    <div class="item" v-for="(item,index) in popoerList" :key="index" :style="{backgroundColor:index%2==1?'#F7FAFC':''}">
                      <div class="time">{{item.time}}</div>
                      <div class="name">{{item.name}}</div>
                      <div class="time">{{item.type}}</div>
                      <div class="line" :style="{'background-color':index%2==1?'#FFC907':''}"></div>
                    </div>
                  </div>
                </template>
                <div class="m-item">
                  <div :class="item.status?'line':''" @mouseenter="hoverProgram(item,index)" @mouseleave="mouseleave(item)">
                    <span class="m-dot" :style="dotBg(item)" v-if="item.status !== 0" ></span>
                  </div>
                </div>
              </a-popover>
              <div class="m-item"  v-else>
                <div :class="item.status?'line':''" @mouseenter="hoverProgram(item,index)" @mouseleave="mouseleave(item)">
                  <span class="m-dot" :style="dotBg(item)" v-if="item.status !== 0" ></span>
                </div>
              </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import calculationTime from '@comm/utils/calculationTime.js'
export default {
  name:'ScheduleCompetition',
  props:{
  },
  data () {
    return {
      dataList:calculationTime.getStartEndAllDays('2023/02/03','2023/02/22'),
      calculationTime,
      projectList: [
        {
          id: 1,
          title: '100米',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-06',
            status: 1
          },{
            day: '2023-02-07',
            status: 2
          },{
            day: '2023-02-08',
            status: 2
          }]
        },
        {
          id: 2,
          title: '200米',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-04',
            status: 1
          },{
            day: '2023-02-05',
            status: 1
          },{
            day: '2023-02-15',
            status: 2
          }]
        },
        {
          id: 3,
          title: '400米',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-04',
            status: 1
          },{
            day: '2023-02-05',
            status: 1
          },{
            day: '2023-02-13',
            status: 2
          }]
        },
        {
          id: 4,
          title: '800米',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-04',
            status: 1
          },{
            day: '2023-02-05',
            status: 1
          },{
            day: '2023-02-12',
            status: 2
          }]
        },
        {
          id: 5,
          title: '1500米',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-04',
            status: 1
          },{
            day: '2023-02-05',
            status: 1
          },{
            day: '2023-02-11',
            status: 2
          }]
        },
        {
          id: 6,
          title: '10000米',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-04',
            status: 1
          },{
            day: '2023-02-05',
            status: 1
          },{
            day: '2023-02-13',
            status: 2
          }]
        },
        {
          id: 8,
          title: '3000米障碍',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-04',
            status: 1
          },{
            day: '2023-02-05',
            status: 1
          },{
            day: '2023-02-18',
            status: 2
          }]
        },
        {
          id: 9,
          title: '100米跨栏',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-08',
            status: 1
          },{
            day: '2023-02-09',
            status: 1
          },{
            day: '2023-02-12',
            status: 2
          }]
        },
        {
          id: 10,
          title: '110米跨栏',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-09',
            status: 1
          },{
            day: '2023-02-10',
            status: 1
          },{
            day: '2023-02-12',
            status: 2
          }]
        },
        {
          id: 11,
          title: '羽毛球',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-14',
            status: 1
          },{
            day: '2023-02-15',
            status: 1
          },{
            day: '2023-02-16',
            status: 2
          }]
        },
        {
          id: 12,
          title: '兵道',
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-13',
            status: 1
          },{
            day: '2023-02-14',
            status: 1
          },{
            day: '2023-02-15',
            status: 1
          },{
            day: '2023-02-16',
            status: 2
          }]
        }
      ],
      mouseIn:false,
      programItem:{},
      popoerList:[
        {
          time:'14:00',
          name:"女子100米",
          type:"半决赛"
        },
        {
          time:'14:00',
          name:"女子100米",
          type:"半决赛"
        },
        {
          time:'14:00',
          name:"女子100米",
          type:"半决赛"
        },
        {
          time:'14:00',
          name:"女子100米",
          type:"半决赛"
        },
        {
          time:'14:00',
          name:"女子100米",
          type:"半决赛"
        },
      ]
    }
  },
  methods: {
    dotBg (item) {
      let colorObj={
        backgroundColor:''
      }
      switch(item.status){
      case 1:
        colorObj.backgroundColor='#009EDF'
        break
      case 2:
        colorObj.backgroundColor='#FFC907'
        break
      case 3:
        colorObj.backgroundColor='#007936'
        break
      default:
        colorObj.backgroundColor='#124584'
      }
      return colorObj 
    },
     hoverProgram(item,index){
      this.mouseIndex=index
      this.mouseIn=true
    },
     mouseleave(){
      this.mouseIn=false
    },
  },
  computed: {
    newProjectList (){
      let arr=[]
      if(this.showNum){
        arr=this.projectList.slice(0,8)
      }else{
        arr = this.projectList
      }
      return arr
    },
   
  },
}
</script>

<style lang="scss" scoped>
.com-sch{
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  margin-bottom: 40px;
  padding-top: 30px;
  .blue{
    background-color: #009EDF;
  }
  .green{
    background-color: #007936;
  }
  .yellow{
    background-color: #FFC907;
  }

  //赛程说明
  .sch-info{
    width: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    //左边
    .sch-left{
      width: 240px;
      box-sizing: border-box;
      border-right: 1px solid #ACD0FD;
      .title{
        width: 100%;
        height: 80px;
        border-bottom: 4px solid #ACD0FD;
        font-weight: bold;
        font-size: 16px;
        padding: 10px 20px;
        .sta-middle{
            display: flex;
            justify-content: flex-start;
            font-size: 14px;
            color: #999999;
            .sta-title{
                height: 30px;
                display: flex;
                margin-right: 20px;
                justify-content: flex-start;
                align-items: center;
                    .dot{
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        border-radius: 50px;
                        margin-right: 5px;
                    }
                }
            }
        }
       .l-col{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-weight: bold;
            border-bottom: 1px solid #ACD0FD;
            padding: 0 20px;
            box-sizing: border-box;
            height: 70px;
            font-size: 18px;
            img{
            width: 60px;
            height: 60px;
            margin-right: 10px;
            }
       }
    }
    //中间
    .sch-middle{
      max-width: 960px;
      // height: 600px;
      box-sizing: border-box;
      overflow: scroll;
      overflow-y:hidden;

      .title{
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        color: #282828;
        .t-item{
          width: 80px;
           border-bottom: 4px solid #ACD0FD;
        .line{
            width: 100%;
            height: 60px;
            position: relative;
            .mouse-cont{
              position: absolute;
              top: 10px;
              left:10px;
              width: 300px;
              height: 50px;
              border: 1px solid red;
              z-index: 999;
            }
        }
        .line::after {
            content: '';
            width: 2px;
            height: 40px;
            background-color: #ACD0FD;
            position: absolute;
            top: 12%;
            right: 0;
        }
          div{
            width: 80px;
            text-align: center;
          }
          .m{
            font-size: 14px;
            height: 25%;
            font-weight: 600;
          }
          .d{
            font-size: 20px;
            font-weight: bold;
          }
          .w{
            font-size: 14px;
             height: 25%;
             font-weight: bold;
          }
        }
      }
      .m-row{
        display: flex;
        width: 100%;
        height: 70px;
        justify-content: flex-start;
        align-items: center;
        line-height: 70px;
        font-weight: bold;
        .m-col{
          height: 100%;
          .m-item{
            width: 80px;
            height: 100%;
            border-bottom: 1px solid #ACD0FD;
            display: flex;
            justify-content: center;
            align-items: center;
            .line{
                width: 100%;
                height: 60px;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                .m-dot{
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 50px;
                    margin:  0 5px;
                }
            }
            .line:hover{
              background-color: #ACD0FD;
            }
            .line::after {
                content: '';
                width: 2px;
                height: 40px;
                background-color: #ACD0FD;
                position: absolute;
                top: 12%;
                right:-1px;
            }
          }
          /deep/ .ant-popover-inner-content{
            width: 320px;
            height: 300px;
            overflow: auto;
            overflow-x: hidden;
            padding: 0;
            box-sizing: border-box;
            border: 1px solid #E1E1E1;
            .item{
              width: 100%;
              position: relative;
              padding: 10px 20px 10px 30px;
              border-bottom: 1px solid #E1E1E1;
              div:first-child{
                width: 100%;
                font-size: 14px;
                color: #999999;
              }
              div:nth-child(2){
                width: 100%;
                font-weight: bold;
                font-size: 14px;
                color: #333333;
                overflow: hidden;
              }
              div:nth-child(3){
                width: 100%;
                font-size: 14px;
                color: #333333;
              }
              div:last-child{
                position: absolute;
                top: 22px;
                left: 0;
                width: 3px;
                height: 40px;
                background-color: #007936;
              }
            }

          }
        }
      }
    }
    //右边
    .sch-right{
      width: 240px;
      box-sizing: border-box;
      .title{
        width: 240px;
        height: 80px;
        border-bottom: 4px solid #ACD0FD;
        border-left: 1px solid #ACD0FD;
        box-sizing: border-box;
        text-align: center;
        color: #282828;
        font-weight: bold;
        font-size: 16px;
        .name{
          width: 240px;
          font-size: 16px;
        }
        .num{
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          box-sizing: border-box;
          .name{
            width: 120px;
            box-sizing: border-box;
            font-size: 14px;
          }
           .num-left{
            width:120px;
            box-sizing: border-box;
            font-size: 14px;
          }
          .num-right{
            width:121px;
            box-sizing: border-box;
            font-size: 14px;
          }
        }
      }
      .r-col{
        width: 240px;
        height: 70px;
        border-bottom:1px solid #ACD0FD;
        display: flex;
        justify-content:justify-content;
        align-items: center;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        line-height: 70px;
        box-sizing: border-box;
        div{
          width: 50%;
          height: 100%;
        }
        
      }
    }
  }
}
.show-bg{
  width: 1200px;
  position: relative;
}

</style>


// WEBPACK FOOTER //
// src/comm/components/match/trackfield/components/TrackfieldSchedule.vue